/**
 * Circle entity → `RenderableEntity` adapter.
 *
 * Stores a parametric `circle` SceneGeometry — the renderer
 * tessellates per camera zoom (LOD) so we don't bake a fixed segment
 * count here.
 */

import type { EntityPreview } from "@dxf-ai-editor/contracts";

import { readPositiveNumber } from "../../scene/renderHelpers";
import type { RenderableEntity } from "../types";

import {
  buildRenderableShell,
  readCenterRaw,
  type AdapterContext,
} from "./adapterContext";
import { buildCircleSceneGeometry } from "./sceneGeometryBuilders";

export function circleToRenderable(
  entity: EntityPreview,
  ctx: AdapterContext,
): RenderableEntity {
  const centerRaw = readCenterRaw(entity.properties);
  const radius = readPositiveNumber(entity.properties, "Radius", 1);

  const { geometry, bounds } = buildCircleSceneGeometry(centerRaw, radius);

  return buildRenderableShell(entity, ctx, geometry, bounds);
}
